module.exports = __webpack_public_path__ + "static/21-ba1f14aed941b62d3a0720ca3dac3635.jpg";